import { render, staticRenderFns } from "./cpSolicitacao.vue?vue&type=template&id=16a3b88c&scoped=true&"
import script from "./cpSolicitacao.vue?vue&type=script&lang=js&"
export * from "./cpSolicitacao.vue?vue&type=script&lang=js&"
import style0 from "./cpSolicitacao.vue?vue&type=style&index=0&id=16a3b88c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16a3b88c",
  null
  
)

export default component.exports